import React from "react";
import { useTranslation } from "react-i18next";
import BackArrowButton from "../parts/back-arrow-button";
import UnitInput from "../parts/inputs/unit-input";
import LoginWrapper from "./LoginWrapper";
import OnboardingRadio from "../parts/inputs/onboarding-radio";

function showRMField(hideRMs, collectRepMax, field) {
  if (collectRepMax?.length > 0) {
    return collectRepMax.includes(field);
  }
  return !hideRMs && ["squat", "bench", "deadlift"].includes(field);
}

const SignupDetailsView = (props) => {
  const { t } = useTranslation("auth");
  React.useEffect(() => {
    document.querySelector('input[name="repMaxSquat"]')?.focus();
  }, []);

  const handleUnitsChange = (to) => {
    props.locals.units = to;
    props.handleFieldChange({ target: { name: "units", value: to } });
  };

  const {
    onBack,
    handleUserDetails,
    handleFieldChange,
    units,
    repMaxSquat,
    repMaxBench,
    repMaxDeadlift,
    repMaxClean,
    repMaxJerk,
    repMaxSnatch,
    repMaxOverheadPress,
  } = props;

  let coachSettings = sessionStorage.getItem("coachSettings");
  if (coachSettings) {
    coachSettings = JSON.parse(coachSettings);
  }
  const hideRMs = !!coachSettings?.hideRepMaximums;
  const collectRepMax = coachSettings?.collectRepMax;
  const showRMText = !hideRMs || collectRepMax?.length > 0;

  return (
    <LoginWrapper
      mainClass="Onboarding athlete profile-details full-w"
      left={
        <form method="POST" data-noreset>
          <section className="mobile-hidden">
            <BackArrowButton onBack={(_) => onBack(4)} />
            <h1>{t("signupDetails.title")}</h1>
            {showRMText && <p>{t("signupDetails.introRm")}</p>}
          </section>
          <header className="only-show-mobile">
            <div>
              <BackArrowButton onBack={(_) => onBack(4)} />
              <div>
                <h1>{t("signupDetails.title")}</h1>
              </div>
            </div>
            {showRMText && <p>{t("signupDetails.introRm")}</p>}
          </header>

          <section>
            <div className="measurement-system">
              <label htmlFor="units">
                {t("signupDetails.measurementSystem")}
              </label>
              <OnboardingRadio
                label={null}
                name="units"
                onClick={handleUnitsChange}
                options={[
                  {
                    value: "metric",
                    label: t("signupDetails.kilogram"),
                    defaultChecked: true,
                  },
                  { value: "imperial", label: t("signupDetails.pound") },
                ]}
                value={units}
              />
            </div>

            {showRMText && (
              <div className="chip info only-show-mobile">
                {t("signupDetails.rmNote")}
              </div>
            )}
            <div className="rep-max">
              {showRMField(hideRMs, collectRepMax, "squat") && (
                <div className="input">
                  <label className="label" htmlFor="squat">
                    {t("signupDetails.squat1rm")}
                  </label>
                  <UnitInput
                    required
                    min="1"
                    metric="kg"
                    imperial="lb"
                    units={units}
                    className="text-input"
                    name="repMaxSquat"
                    value={repMaxSquat || ""}
                    handleChange={handleFieldChange}
                    placeholder={t("signupDetails.enterHere")}
                  />
                  <span className="unit">
                    {units === "imperial" ? "LB" : "KG"}
                  </span>
                </div>
              )}
              {showRMField(hideRMs, collectRepMax, "bench") && (
                <div className="input">
                  <label className="label" htmlFor="bench">
                    {t("signupDetails.bench1rm")}
                  </label>
                  <UnitInput
                    required
                    min="1"
                    metric="kg"
                    units={units}
                    imperial="lb"
                    className="text-input"
                    name="repMaxBench"
                    value={repMaxBench || ""}
                    handleChange={handleFieldChange}
                    placeholder={t("signupDetails.enterHere")}
                  />
                  <span className="unit">
                    {units === "imperial" ? "LB" : "KG"}
                  </span>
                </div>
              )}
              {showRMField(hideRMs, collectRepMax, "deadlift") && (
                <div className="input">
                  <label className="label" htmlFor="deadlift">
                    {t("signupDetails.deadlift1rm")}
                  </label>
                  <UnitInput
                    required
                    min="1"
                    metric="kg"
                    imperial="lb"
                    units={units}
                    className="text-input"
                    name="repMaxDeadlift"
                    value={repMaxDeadlift || ""}
                    handleChange={handleFieldChange}
                    placeholder={t("signupDetails.enterHere")}
                  />
                  <span className="unit">
                    {units === "imperial" ? "LB" : "KG"}
                  </span>
                </div>
              )}
              {showRMField(hideRMs, collectRepMax, "clean") && (
                <div className="input">
                  <label className="label" htmlFor="repMaxClean">
                    {t("signupDetails.clean1rm")}
                  </label>
                  <UnitInput
                    required
                    min="1"
                    metric="kg"
                    imperial="lb"
                    units={units}
                    className="text-input"
                    name="repMaxClean"
                    value={repMaxClean || ""}
                    handleChange={handleFieldChange}
                    placeholder={t("signupDetails.enterHere")}
                  />
                  <span className="unit">
                    {units === "imperial" ? "LB" : "KG"}
                  </span>
                </div>
              )}
              {showRMField(hideRMs, collectRepMax, "jerk") && (
                <div className="input">
                  <label className="label" htmlFor="repMaxJerk">
                    {t("signupDetails.jerk1rm")}
                  </label>
                  <UnitInput
                    required
                    min="1"
                    metric="kg"
                    imperial="lb"
                    units={units}
                    className="text-input"
                    name="repMaxJerk"
                    value={repMaxJerk || ""}
                    handleChange={handleFieldChange}
                    placeholder={t("signupDetails.enterHere")}
                  />
                  <span className="unit">
                    {units === "imperial" ? "LB" : "KG"}
                  </span>
                </div>
              )}
              {showRMField(hideRMs, collectRepMax, "snatch") && (
                <div className="input">
                  <label className="label" htmlFor="repMaxSnatch">
                    {t("signupDetails.snatch1rm")}
                  </label>
                  <UnitInput
                    required
                    min="1"
                    metric="kg"
                    imperial="lb"
                    units={units}
                    className="text-input"
                    name="repMaxSnatch"
                    value={repMaxSnatch || ""}
                    handleChange={handleFieldChange}
                    placeholder={t("signupDetails.enterHere")}
                  />
                  <span className="unit">
                    {units === "imperial" ? "LB" : "KG"}
                  </span>
                </div>
              )}
              {showRMField(hideRMs, collectRepMax, "overheadPress") && (
                <div className="input">
                  <label className="label" htmlFor="repMaxOverheadPress">
                    {t("signupDetails.overheadPress1rm")}
                  </label>
                  <UnitInput
                    required
                    min="1"
                    metric="kg"
                    imperial="lb"
                    units={units}
                    className="text-input"
                    name="repMaxOverheadPress"
                    value={repMaxOverheadPress || ""}
                    handleChange={handleFieldChange}
                    placeholder={t("signupDetails.enterHere")}
                  />
                  <span className="unit">
                    {units === "imperial" ? "LB" : "KG"}
                  </span>
                </div>
              )}
            </div>

            {showRMText && (
              <div className="chip info mt-4 mobile-hidden">
                {t("signupDetails.rmNote")}
              </div>
            )}

            <label className="checkbox-input mt-4 flex! opacity-100!">
              <input
                name="agreeTOS"
                type="checkbox"
                id="tos"
                onChange={handleFieldChange}
              />{" "}
              {t("signupDetails.agreeTerms")}{" "}
              <a
                href="https://mystrengthbook.com/terms-of-use/"
                target="_blank"
                rel="noopener noreferrer"
                data-button-type="text"
                role="button"
                className="m-0! p-0! w-auto!"
              >
                {t("signupDetails.termsOfUse")}
              </a>
            </label>
          </section>

          <button
            data-button-type="primary"
            sz="large"
            onClick={handleUserDetails}
            className="mobile-hidden w-1/2!"
          >
            {t("signupDetails.continue")}
          </button>
          <button
            data-button-type="primary"
            sz="large"
            onClick={handleUserDetails}
            className="only-show-mobile"
          >
            {t("signupDetails.continue")}
          </button>
        </form>
      }
    />
  );
};

export default SignupDetailsView;
